import { forwardRef } from '@chakra-ui/react';

import { ButtonGroup, type ButtonGroupProps } from '@frontend/components';

import { usePopoverContext } from './utils/PopoverContext';

export type PopoverButtonGroupProps = ButtonGroupProps;

export const PopoverButtonGroup = forwardRef<PopoverButtonGroupProps, 'div'>(
  ({ children, ...restProps }: PopoverButtonGroupProps, ref) => {
    const { size } = usePopoverContext();

    return (
      <ButtonGroup justifySelf="end" ref={ref} size={size} {...restProps}>
        {children}
      </ButtonGroup>
    );
  },
);
PopoverButtonGroup.displayName = 'PopoverButtonGroup';
